/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { UserStatus } from '@gh/builder-shared-data';
import {
  rendererIconByName,
  ROW_DELETED_CLASS,
  truthyCellRenderer,
} from '@gh/common-internal-shared';
import { buildDateTimeColumn, LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { UserListItem } from '../../resources/user-list-item.model';
import { DateTimeTypes } from '@gh/common-shared';


@Injectable()
export class UserGridDefinition extends LayoutBasedGridDefinition {

  columnDefs = {
    status: {
      minWidth: 105,
      cellClass: ({ data }: { data: UserListItem }) => ({
        [UserStatus.Active]: 'active-status',
        [UserStatus.Inactive]: 'inactive-status',
        [UserStatus.Deleted]: 'deleted-status',
        [UserStatus.Transferred]: 'transfered-status',
        [UserStatus.In_Deletion]: 'inDeletion-status',
      }[data.statusValue || '']),
    },

    systemRoles: {
      headerName: 'System Role',
      field: 'systemRoles',
      sortable: true,
      comparator: (a: string, b: string) => (a || '').localeCompare(b || ''),
    },

    isDriveOwner: {
      headerName: 'Drive Owner',
      valueGetter: ({ data }: { data: UserListItem }) => data.first,
      cellRenderer: truthyCellRenderer(rendererIconByName('done')),
      sortable: true,
      comparator: (a: boolean, b: boolean) => Number(a) - Number(b),
    },

    lastLoginTime: {
      ...buildDateTimeColumn(DateTimeTypes.Timestamp),
      sortable: true,
      comparator: (a: string, b: string) => new Date(a).getTime() - new Date(b).getTime(),
    },
  };

  options = {
    rowClassRules: {
      [ROW_DELETED_CLASS]: ({ data }: { data: UserListItem }) => data.statusValue === UserStatus.Deleted,
    },
    getRowId: (params) => String(params.data.userId),
  };
}
